import { createFileRoute, Navigate } from "@tanstack/react-router";
import React from "react";

/**
 * The properties for {@link ExitNodeRedirect}
 */
export type ExitNodeRedirectProps = {};

/**
 * Redirect page for exit nodes
 */
export default function ExitNodeRedirect(props: ExitNodeRedirectProps) {
    return <Navigate to={"/a/exitnodes/approved"} search={{ page: 1 }} />;
}

export const Route = createFileRoute("/_admin/a/exitnodes/")({
    component: ExitNodeRedirect,
});
